<div>
  <div class="title">
    <h2 class="primary" i18n="@@Create Project">Create Project</h2>
  </div>
  <div>
    <form [formGroup]="changeForm" (change)="formChanged()">
      <!--
        Was: `Parent folder [{{selectedFolder}}]`, which rendered
        "Parent folder [/]" at the tree root — the internal spelling of
        "no folder", shown to the user as if it were a location.
      -->
      <app-folder-path [path]="selectedFolder"><ng-container i18n="@@Location">Location</ng-container></app-folder-path>
      <div class="text-inside">
        <mat-form-field class="full-width">
          <mat-label i18n="@@Project Name">Project Name</mat-label>
          <input formControlName="newProjectName" matInput i18n-placeholder="@@Project Name" placeholder="Project Name" type="text" name="first-name" (input)="update()" (blur)="update()" (change)="update()" required/>
        </mat-form-field>
      </div>
      <!--
        Start a Draft with the Project (default ON).

        An empty Project cannot be ordered, printed or sold — the
        operator's next step is always to add content, and from a
        standing start that means a Draft with an interior PDF and a
        cover PDF. Leaving this ticked creates that Draft and opens
        its editor straight away; unticking it produces a bare
        Project for operators who are about to file existing Books
        and Drafts into it.
      -->
      <div class="text-inside">
        <mat-checkbox [(ngModel)]="createDraft" [ngModelOptions]="{standalone: true}" color="primary">
          <span i18n="@@Start a Draft in this Project">Start a Draft in this Project</span>
        </mat-checkbox>
        <div class="create-project-hint" *ngIf="createDraft" i18n="@@createProjectDraftHint">
          The Draft opens after the Project is created so you can enter the title and author and upload the interior and cover PDFs.
        </div>
      </div>
      <div class="create-project-error" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="btn-sec">
        <button mat-raised-button type="button" class="Discard-btn" mat-dialog-close="" i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
        <button mat-raised-button type="submit" color="primary" class="Update-btn" [disabled]="changeForm.invalid || !validProjectName || creating" (click)="onChange()"><span i18n="@@Create Project">Create Project</span>&nbsp;{{ newProjectName }}</button>
      </div>
    </form>
  </div>
</div>
